// extracted by mini-css-extract-plugin
export default {"socialEngagementCard":"SocialEngagementCard_socialEngagementCard__4gi4P"};